export const scrollToBottom = (): void => {
    window.scrollTo(0, document.body.scrollHeight)
}
